var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-start shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('div', {
    staticClass: "shadow-border-b p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info Kurir")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("ID")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.id))])]), _c('div', {
    staticClass: "mb-6 flex gap-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.name))])]), _c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("No. Handphone")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.phone_number))])])]), _c('div', {
    staticClass: "mb-6 flex gap-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Jenis Kelamin")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.genderMapping[_vm.courierDetail.gender]))])]), _c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Email")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.email))])])]), _c('div', {
    staticClass: "flex gap-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Area")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.area_name))])]), _c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Status")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.availability_status))])])])]), _c('div', {
    staticClass: "flex-1 p-6 mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("KTP & SIM")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("No KTP")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.id_card_number))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Tipe SIM")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.driver_license_type))])]), _c('div', {}, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("No SIM")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.driver_license_number))])])])]), _c('div', {
    staticClass: "flex-1 p-6 mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Informasi Bank")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Bank")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.bank_name))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("No. Rekening")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.bank_account))])]), _c('div', {}, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pemilik Rekening")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.courierDetail.bank_account_holder))])])])]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end mdmax:justify-center"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Hapus",
      "type": "delete",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.submit();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Edit",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.submit();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }